import React, { useMemo, useState } from 'react'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

import { customStyles, styles } from './styles'
import Select, { components } from 'react-select'
import { LanguageArrowDown } from '../../../../uiKit/icons/LanguageArrowDown'
import { LanguageArrowUp } from '../../../../uiKit/icons/LanguageArrowUp'

const Index = props => {
  const { onChange, value, classes } = props
  const [isOpen, setIsOpen] = useState(false)
  const options = useMemo(
    () => [
      {
        value: 'ALL',
        label: 'All conversations',
        dataAutotest: 'all-conversations-option'
      },
      {
        value: 'COMPLETED_NEXT_STEP',
        label: 'Completed next step',
        dataAutotest: 'completed-next-step-option'
      },
      {
        value: 'DROP_OFF',
        label: 'Dropped off this step',
        dataAutotest: 'drop-off-option'
      },
    ],
    [],
  )

  const SingleValue = props => {
    return (
      <components.SingleValue {...props}
        innerProps={{ ...props.innerProps, 'data-autotest': 'open-filter-popup-button' }}>
        {props.children}
        <span className={classes.arrow}>{isOpen ? <LanguageArrowUp /> : <LanguageArrowDown />}</span>
      </components.SingleValue>
    )
  }

  const Option = props => {
    return (
      <components.Option {...props} innerProps={{ ...props.innerProps, 'data-autotest': props.data.dataAutotest }}>
        {props.children}
      </components.Option>
    )
  }

  return (
    <Select
      options={options}
      value={value}
      styles={customStyles}
      isSearchable={false}
      onChange={onChange}
      components={{ SingleValue, Option }}
      onMenuOpen={() => setIsOpen(true)}
      onMenuClose={() => setIsOpen(false)}
    />
  )
}

Index.propTypes = {
  classes: PropTypes.object,
}

export default withStyles(styles)(Index)
